
import { useEffect } from 'react';

export default function ContentProtection() {
  useEffect(() => {
    // Deshabilitar clic derecho
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      return false;
    };

    // Deshabilitar teclas de captura de pantalla y copiar
    const handleKeyDown = (e: KeyboardEvent) => {
      // Deshabilitar Print Screen
      if (e.key === 'PrintScreen') {
        e.preventDefault();
        return false;
      }

      // Deshabilitar Ctrl+C, Ctrl+X, Ctrl+A, Ctrl+S, Ctrl+P
      if (e.ctrlKey && ['c', 'x', 'a', 's', 'p'].includes(e.key.toLowerCase())) {
        e.preventDefault();
        return false;
      }

      // Deshabilitar Cmd+C, Cmd+X, Cmd+A, Cmd+S, Cmd+P en Mac
      if (e.metaKey && ['c', 'x', 'a', 's', 'p'].includes(e.key.toLowerCase())) {
        e.preventDefault();
        return false;
      }

      // Deshabilitar F12 (DevTools)
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }

      // Deshabilitar Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+Shift+C (DevTools)
      if (e.ctrlKey && e.shiftKey && ['i', 'j', 'c'].includes(e.key.toLowerCase())) {
        e.preventDefault();
        return false;
      }
    };

    // Deshabilitar arrastrar imágenes
    const handleDragStart = (e: DragEvent) => {
      e.preventDefault();
      return false;
    };

    // Detectar cambio de visibilidad (posible captura de pantalla)
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Opcional: registrar intento de captura
        console.warn('Posible intento de captura de pantalla detectado');
      }
    };

    // Agregar event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('dragstart', handleDragStart);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Deshabilitar selección de texto en todo el documento
    document.body.style.userSelect = 'none';
    document.body.style.webkitUserSelect = 'none';

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('dragstart', handleDragStart);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      document.body.style.userSelect = '';
      document.body.style.webkitUserSelect = '';
    };
  }, []);

  return null;
}
